<template>
  <div>
    <div class="man-cell" style="margin: 10px">
      <el-input v-model="search" placeholder="微信公众号名称："></el-input>
    </div>
    <el-button style="margin: 10px" type="primary" @click="getMedia"
      >搜索</el-button
    >
    <el-button
      type="primary"
      @click="
        showDialog = true;
        edit = false;
        onRest();
      "
      >添加新微信公众号</el-button
    >
    <el-table
      :data="tableData"
      highlight-current-row
      style="width: 100%"
      v-loading="loading"
    >
      <el-table-column label="微信公众号名称" prop="name"></el-table-column>
      <el-table-column label="头条价" prop="official_media.topPrice">
        <template slot-scope="scope">
          {{ scope.row.official_media.topPrice + scope.row.addPrice }}
        </template>
      </el-table-column>
      <el-table-column label="普发价" prop="official_media.normalPrice">
        <template slot-scope="scope">
          {{ scope.row.official_media.normalPrice + scope.row.addPrice }}
        </template>
      </el-table-column>
      <el-table-column label="门户" prop="portal"></el-table-column>
      <el-table-column label="行业" prop="channel"></el-table-column>
      <el-table-column label="地区" prop="area"></el-table-column>
      <!-- <el-table-column label="可带链接" prop="linkable"></el-table-column>
      <el-table-column label="联系方式" prop="contactable"></el-table-column> -->
      <el-table-column label="出稿率" prop="rate"></el-table-column>
      <el-table-column label="出稿速度" prop="speed"></el-table-column>
      <el-table-column
        label="参考粉丝量"
        prop="official_media.fans"
      ></el-table-column>
      <el-table-column
        label="参考阅读量"
        prop="official_media.reading"
      ></el-table-column>
      <!-- <el-table-column label="平台认证" prop="auth"></el-table-column> -->
      <el-table-column property="openid" label="编辑">
        <template slot-scope="scope">
          <el-button size="mini" @click="onEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="Pagination" style="text-align: left; margin-top: 10px">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="index"
        :page-size="20"
        layout="total, prev, pager, next"
        :total="count"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="!edit ? '添加' : '修改' + '微信公众号'"
      :visible.sync="showDialog"
      width="50%"
    >
      <el-form ref="form" label-width="100px">
        <el-form ref="form" label-width="100px">
          <el-form-item label="微信公众号名称：" style="width: 50%; float: left">
            <el-input style="width: 80%" size="small" v-model="name"></el-input>
          </el-form-item>
          <el-form-item label="头条价格：" style="width: 50%; float: left">
            <el-input
              style="width: 80%"
              size="small"
              v-model="topPrice"
            ></el-input>
          </el-form-item>
          <el-form-item label="普条价格：" style="width: 50%; float: left">
            <el-input
              style="width: 80%"
              size="small"
              v-model="normalPrice"
            ></el-input>
          </el-form-item>
          <el-form-item label="粉丝数：" style="width: 50%; float: left">
            <el-input
              style="width: 80%"
              size="small"
              type="number"
              v-model="fans"
            ></el-input>
            <!-- <el-select v-model="fans" placeholder="请选择">
              <el-option
                v-for="(item,index) in fansList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="参考阅读量：" style="width: 50%; float: left">
            <el-input
              style="width: 80%"
              size="small"
              type="number"
              v-model="reading"
            ></el-input>
            <!-- <el-select v-model="reading" placeholder="请选择"> 
              <el-option
                v-for="(item,index) in readList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="微信公众号类型：" style="width: 50%; float: left">
            <el-select
              v-model="lanuch"
              placeholder="请选择"
            >
              <el-option
                v-for="item in lanuchList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="其他选项：" style="width: 50%; float: left">
            <el-select v-model="others" placeholder="请选择">
              <el-option
                v-for="(item, index) in othersList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="行业类型：" style="width: 50%; float: left">
            <el-select v-model="channel" placeholder="请选择">
              <el-option
                v-for="(item, index) in channelList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地区：" style="width: 50%; float: left">
          <el-cascader v-model="city" :options="areaList" :props="{ value:'label' }"  separator='-' filterable clearable @change="choseCity"></el-cascader>
 
          </el-form-item>
          <el-form-item label="知名门户：" style="width: 50%; float: left">
            <el-select v-model="portal" placeholder="请选择">
              <el-option
                v-for="(item, index) in portalList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="带链接：" style="width: 50%; float: left">
            <el-select v-model="linkable" placeholder="请选择">
              <el-option
                v-for="(item,index) in boolList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="带联系方式：" style="width: 50%; float: left">
            <el-select v-model="contactable" placeholder="请选择">
              <el-option
                v-for="(item,index) in boolList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="案例链接：" style="clear: both">
            <el-input
              style="width: 80%"
              type="textarea"
              size="small"
              v-model="mediaCase"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注：" style="clear: both">
            <el-input
              style="width: 80%"
              type="textarea"
              size="small"
              v-model="remark"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" @click="onChange">{{
          edit ? "确认修改" : "确认添加"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import myAxios from "../myAxios";
import areaJson from "../components/area.json";
import cityList from "../components/city.json";
export default {
  data() {
    return {
      city:"",
      count: 0,
      mediaId: "",
      size: 20,
      index: 1,
      tableData: [],
      loading: false,
      lanuch: "不限",
      lanuchList: [
        // 官方微信公众号号 非官方微信公众号号
        { value: "不限", label: "不限" },
        { value: "官方微信公众号号", label: "官方微信公众号号" },
        { value: "非官方微信公众号号", label: "非官方微信公众号号" }
      ],
      username: localStorage.getItem("username"),
      showDialog: false,
      search: "",
      name: "", //微信公众号名称
      topPrice: 0, //头条价格
      normalPrice: 0, //普条价格
      fans: "", //参考粉丝数
      reading: "", //参考阅读量
      mediaCase: "", //微信公众号案例
      portal: "", //知名门户号
      channel: "", //行业类型
      area: "", //所属区域
      contactable: false, //是否带链接
      linkable: false, //是否带联系方式
      others: "", //其他选项
      remark: "", //备注
      edit: false,
      areaList: [],
      channelList: [],
      boolList: [
        {
          value: true,
          label: "是",
        },
        {
          value: false,
          label: "否",
        },
      ],
      othersList: [
        {
          value: "不限",
          label: "不限",
        },
        {
          value: "工作日可发",
          label: "工作日可发",
        },
        {
          value: "节假日可发",
          label: "节假日可发",
        },
        {
          value: "预约发布",
          label: "预约发布",
        },
      ],
      //
      readList: [
        {
          value: "1000以下",
          label: "1000以下",
        },
        {
          value: "1000-5000",
          label: "1000-5000",
        },
        {
          value: "5000-1万",
          label: "5000-1万",
        },
      ],
      portalList: [],
      fansList: [
        {
          value: "1万以下",
          label: "1万以下",
        },
        {
          value: "1万-5万",
          label: "1万-5万",
        },
        {
          value: "5万-10万",
          label: "5万-10万",
        },
      ],
    };
  },
  created() {
    this.portalList = areaJson.newPortalList;
    this.channelList = areaJson.gzhChannelList;
    this.areaList = cityList;
    this.getMedia();
  },
  computed: {},
  methods: {
        choseCity(e){
      this.area=e[0]+"-"+e[1]
      console.log(this.area)
    },
    async getMedia() {
      myAxios
        .get(
          `/client_media/MyMedia/v1?username=${
            this.username
          }&name=${this.search.replace(/\s*/g, "")}&mediaType=3&index=${
            this.index
          }&size=${this.size}`
        )
        .then((res) => {
          this.tableData = res.data;
          this.count = res.total;
        });
      this.loading = false;
    },
    handleCurrentChange(val) {
      console.log(val);
      this.index = val;
      this.getMedia();
    },
    onEdit(index, row) {
      this.edit = true;
      this.mediaId = row.official_media.mediaId;
      this.showDialog = true;
      this.name = row.name; //微信公众号名称
      this.topPrice = row.official_media.topPrice; //头条价格
      this.normalPrice = row.official_media.normalPrice; //普条价格
      this.fans = row.official_media.fans; //参考粉丝数
      this.reading = row.official_media.reading; //参考阅读量
      this.mediaCase = row.mediaCase; //微信公众号案例
      this.portal = row.portal; //知名门户号
      this.channel = row.channel; //行业类型
      this.area = row.area; //所属区域
      this.contactable = row.contactable; //是否带链接
      this.linkable = row.linkable; //是否带联系方式
      this.others = row.others; //其他选项
      this.remark = row.remark; //备注
      this.lanuch = row.lanuch;
    },
    onRest() {
      this.mediaId = "";
      this.name = ""; //微信公众号名称
      this.topPrice = 0; //头条价格
      this.normalPrice = 0; //普条价格
      this.fans = 0; //参考粉丝数
      this.reading = 0; //参考阅读量
      this.mediaCase = ""; //微信公众号案例
      this.portal = ""; //知名门户号
      this.channel = ""; //行业类型
      this.area = ""; //所属区域
      this.contactable = false; //是否带链接
      this.linkable = false; //是否带联系方式
      this.others = ""; //其他选项
      this.remark = ""; //备注
      this.lanuch = "";
    },
    onChange() {
      console.log("this.name ",this.name ,
        "this.topPrice" ,this.topPrice ,
        "this.normalPrice",this.normalPrice,
        "this.fans",this.fans,
        "this.reading" , this.reading ,
        "this.portal",this.portal,
        "this.channel" ,this.channel ,
        "this.area" ,this.area ,
        "this.contactable" ,this.contactable ,
        "this.linkable", this.linkable,
        "this.others",this.others,
        "this.lanuch",this.lanuch,)
      // return 
      if (
        this.name == "" ||
        this.topPrice == "" ||
        this.normalPrice == "" ||
        this.fans == "" ||
        this.reading == "" ||
        this.portal == "" ||
        this.channel == "" ||
        this.area == "" ||
        this.others == "" ||
        this.lanuch == ""
      ) {
        this.$alert("信息填写不全", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if (this.topPrice <= 0 || this.normalPrice <= 0) {
        this.$alert("金额不小于0", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      var url = `/client_media/AddOfficialMedia/v1?remark=${this.remark}&linkable=${this.linkable}&username=${this.username}&name=${this.name}&topPrice=${this.topPrice}&normalPrice=${this.normalPrice}&fans=${this.fans}&reading=${this.reading}&mediaCase=${this.mediaCase}&portal=${this.portal}&channel=${this.channel}&area=${this.area}&contactable=${this.contactable}&others=${this.others}&lanuch=${this.lanuch}`;
      if (this.edit) {
        url = `/client_media/UpdateOfficialMedia/v1`;
		var data={
			mediaId:this.mediaId,
			remark:this.remark,
			linkable:this.linkable,
			username:this.username,
			name:this.name,
			topPrice:this.topPrice,
			normalPrice:this.normalPrice,
			fans:this.fans,
			reading:this.reading,
			mediaCase:this.mediaCase,
			portal:this.portal,
			channel:this.channel,
			area:this.area,
			contactable:this.contactable,
			others:this.others,
			lanuch:this.lanuch,
		}
		myAxios.post(url,data).then((res) => {
		  if (res.code == 0) {
		    this.onRest();
		    this.getMedia();
		    this.showDialog = false;
		    this.$message({
		      type: "success",
		      message: res.data,
		    });
		  }
		});
      }
	  else{
		  myAxios.post(url).then((res) => {
		    if (res.code == 0) {
		      this.onRest();
		      this.getMedia();
		      this.showDialog = false;
		      this.$message({
		        type: "success",
		        message: res.data,
		      });
		    }
		  });
	  }
    },
  },
};
</script>

<style lang="less">
</style>
